/* ATOM LED datasheet index. Progressive enhancement: all rows are server-rendered,
   this only hides and shows. Matching is deliberately dumb - exact substring against
   two normalised forms. No fuzzy scoring: on part numbers, CP16X16 softly matching
   CP16X10 hands the contractor the wrong sheet. */
(function () {
  var root = document.querySelector('[data-atom-ds]');
  if (!root) return;

  var input = root.querySelector('[data-ds-search]');
  var clear = root.querySelector('[data-ds-clear]');
  var num   = root.querySelector('[data-ds-num]');
  var lab   = root.querySelector('[data-ds-numlabel]');
  var chips = [].slice.call(root.querySelectorAll('[data-ds-chip]'));
  var rows  = [].slice.call(root.querySelectorAll('[data-ds-row]'));
  var subs  = [].slice.call(root.querySelectorAll('[data-ds-subwrap]'));
  var groups= [].slice.call(root.querySelectorAll('[data-ds-group]'));
  var TOTAL_DOCS = parseInt(root.getAttribute('data-total-docs'), 10) || 0;
  var TOTAL_PROD = rows.length;
  var activeCat = '';
  var timer;

  rows.forEach(function (r) {
    r._i = ' ' + (r.getAttribute('data-i') || '') + ' ';   // spaced words
    r._f = (r.getAttribute('data-f') || '');               // alphanumeric only
    r._d = parseInt(r.getAttribute('data-d'), 10) || 0;    // documents on this row
  });

  function apply() {
    var raw = input ? input.value : '';
    var spaced = raw.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    var flat   = raw.toLowerCase().replace(/[^a-z0-9]+/g, '');
    var tokens = spaced ? spaced.split(' ') : [];
    var prod = 0, docs = 0;

    rows.forEach(function (row) {
      var okCat = !activeCat || row.getAttribute('data-cat') === activeCat;
      // every token must appear, in either normalised form
      var okQ = !tokens.length || tokens.every(function (t) {
        return row._i.indexOf(t) !== -1;
      }) || (flat && row._f.indexOf(flat) !== -1);
      var show = okCat && okQ;
      row.hidden = !show;
      if (show) { prod++; docs += row._d; }
    });

    subs.forEach(function (w) { w.hidden = !w.querySelector('[data-ds-row]:not([hidden])'); });
    groups.forEach(function (g) {
      g.hidden = !g.querySelector('[data-ds-row]:not([hidden])');
      if (g.hidden) return;
      var vis = [].slice.call(g.querySelectorAll('[data-ds-row]:not([hidden])'));
      var d = vis.reduce(function (a, r) { return a + r._d; }, 0);
      var c = g.querySelector('[data-ds-groupcount]');
      if (c) c.textContent = vis.length + (vis.length === 1 ? ' product · ' : ' products · ') +
                             d + (d === 1 ? ' document' : ' documents');
    });

    root.classList.toggle('is-empty', prod === 0);
    root.classList.toggle('is-searching', !!raw);

    if (num) num.textContent = docs;
    if (lab) {
      if (raw) {
        var q = raw.length > 24 ? raw.slice(0, 24) + '…' : raw;
        lab.textContent = 'matching “' + q + '”';
      } else {
        lab.textContent = 'documents · ' + prod + (prod === 1 ? ' product' : ' products');
      }
    }
  }

  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(timer); timer = setTimeout(apply, 100);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) { input.value = ''; apply(); }
    });
    // "/" focuses the field, the way a terminal would
    document.addEventListener('keydown', function (e) {
      if (e.key === '/' && document.activeElement !== input &&
          !/^(INPUT|TEXTAREA|SELECT)$/.test((document.activeElement || {}).tagName || '')) {
        e.preventDefault(); input.focus(); input.select();
      }
    });
  }
  if (clear) clear.addEventListener('click', function () {
    input.value = ''; apply(); input.focus();
  });
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var cat = chip.getAttribute('data-ds-chip');
      activeCat = (activeCat === cat) ? '' : cat;
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', c.getAttribute('data-ds-chip') === activeCat ? 'true' : 'false');
      });
      apply();
    });
  });

  apply();
})();
